import { Children } from "react";
import { Field, FormGroup } from "../../../components/form";
import * as Yup from "yup";

function calculateDisabledProp(context: any, model: any): boolean {
  return context.disabled || model.doesChildAttend == false || model.doesChildAttend == undefined;
}

function calculateValue(model: any, valueInstance: any, returnValue: any): any {
  if (model.doesChildAttend == false || model.doesChildAttend == undefined) {
    return returnValue;
  }
  return valueInstance;
}

function generateFormFields() {
  const daysOfTheWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  const formgroup: FormGroup[] = [];

  formgroup.push({
    type: "formGroup",
    fields: [
      {
        type: "field",
        key: "advisory",
        fieldType: "advisory",
        label: "What days does the child attend the service?",
      },
      {
        type: "field",
        key: "advisory7",
        fieldType: "advisory",
        props: {
          type: "fieldadv",
          Body: () => <div>Please tick all days that apply</div>,
        },
      },
    ],
  });

  daysOfTheWeek.map((day) => {
    formgroup.push({
      type: "formGroup",
      key: day,
      fields: [
        {
          type: "field",
          label: day,
          key: "doesChildAttend",
          fieldType: "checkbox",
        },
        ...dayForm,
      ],
    });
  });

  return formgroup;
}

const dayForm: Field[] = [
  {
    type: "field",
    key: "startTime",
    fieldType: "time",
    label: "Start time",
    expressionProps: {
      disabled: (context, values, model) => {
        return calculateDisabledProp(context, model);
      },
    },
    calculatedValue: (context, values, model) => {
      return calculateValue(model, model.startTime, null);
    },
    hideExpression: (context, values, model) => {
      return !model.doesChildAttend;
    },
    validation: Yup.string().when(["doesChildAttend", "endTime"], ([doesChildAttend, endTime], schema) => {
      if (doesChildAttend != true) {
        return schema.notRequired();
      }
      if (endTime == null) {
        return schema.required("A response is required");
      } else {
        return schema
          .required("A response is required")
          .test("start-before-end", "The start time may not be later than the end time", function (startTime) {
            // if either value is missing, let "required" handle it
            if (!startTime || !endTime) return true;

            return startTime <= endTime;
          });
      }
    }),
  },
  {
    type: "field",
    key: "endTime",
    fieldType: "time",
    label: "End time",
    expressionProps: {
      disabled: (context, values, model) => {
        return calculateDisabledProp(context, model);
      },
    },
    calculatedValue: (context, values, model) => {
      return calculateValue(model, model.endTime, null);
    },
    hideExpression: (context, values, model) => {
      return !model.doesChildAttend;
    },
    validation: Yup.string().when(["doesChildAttend"], ([doesChildAttend], schema) => {
      if (doesChildAttend != true) {
        return schema.notRequired();
      }
      return schema.required("A response is required");
    }),
  },
  {
    type: "field",
    key: "groupNames",
    fieldType: "input",
    label: "What is the name of the group the child attends on this day?",
    expressionProps: {
      disabled: (context, values, model) => {
        return calculateDisabledProp(context, model);
      },
    },
    calculatedValue: (context, values, model) => {
      return calculateValue(model, model.groupNames, "");
    },
    hideExpression: (context, values, model) => {
      return !model.doesChildAttend;
    },
    validation: Yup.string().when(["doesChildAttend"], ([doesChildAttend], schema) => {
      if (doesChildAttend != true) {
        return schema.notRequired();
      }
      return schema.required("A response is required");
    }),
  },
  {
    type: "field",
    key: "otherGroups",
    fieldType: "radio",
    label: (
      <>
        Are there any groups that are also running <strong>in the same room as the child</strong> on this day?
      </>
    ),
    hideExpression: (context, values, model) => {
      return !model.doesChildAttend;
    },
    validation: Yup.string().when(["doesChildAttend"], ([doesChildAttend], schema) => {
      if (doesChildAttend != true) {
        return schema.notRequired();
      }
      return schema.required("A response is required");
    }),
    props: {
      options: [
        {
          label: "Yes",
          value: true,
        },
        {
          label: "No",
          value: false,
        },
      ],
    },
  },
  {
    type: "field",
    key: "otherGroupNames",
    fieldType: "input",
    label: (
      <>
        What are the names of the other groups that are also running <strong>in the same room</strong> as the child on this day?
      </>
    ),
    hideExpression: (context, values, model) => {
      return !model.doesChildAttend || model.otherGroups != true;
    },
    validation: Yup.string().when(["otherGroups"], ([otherGroups], schema) => {
      if (otherGroups != "true") {
        return schema.notRequired();
      }
      return schema.required("A response is required");
    }),
  },
  {
    type: "field",
    key: "advisory7",
    fieldType: "advisory",
    hideExpression: (context, values, model) => {
      return !model.doesChildAttend || model.otherGroups != true;
    },
    props: {
      type: "fieldadv",
      Body: () => (
        <div>If multiple groups attend with this child (i.e. a rotational model) please list all group names separately, separated by a comma</div>
      ),
    },
  },
  {
    type: "field",
    key: "childrenAttendance",
    fieldType: "number",
    label: (
      <>
        How many children <u>in total</u> are there <strong>in the same room</strong> as the child on this day?
      </>
    ),
    expressionProps: {
      disabled: (context, values, model) => {
        return calculateDisabledProp(context, model);
      },
    },
    calculatedValue: (context, values, model) => {
      return calculateValue(model, model.childrenAttendance, "");
    },
    hideExpression: (context, values, model) => {
      return !model.doesChildAttend;
    },
    validation: Yup.number().when(["doesChildAttend"], ([doesChildAttend], schema) => {
      if (doesChildAttend != true) {
        return schema.notRequired();
      }
      return schema
        .required("A response is required")
        .min(1, "Please enter a number between 1 and 50")
        .max(50, "Please enter a number between 1 and 50");
    }),
  },
  {
    type: "field",
    key: "advisory",
    fieldType: "advisory",
    props: {
      type: "fieldadv",
      Body: () => (
        <div>
          {" "}
          Please enter the total number of children <strong>in the same room</strong> regardless of if they are in the same group (including the child
          in the application)
        </div>
      ),
    },

    hideExpression: (context, values, model) => {
      return !model.doesChildAttend;
    },
  },
  {
    type: "field",
    key: "staffAttendance",
    fieldType: "number",
    label: (
      <>
        How many staff <u>in total</u> are there <strong>in the same room</strong> as the child on this day?
      </>
    ),
    expressionProps: {
      disabled: (context, values, model) => {
        return calculateDisabledProp(context, model);
      },
    },
    calculatedValue: (context, values, model) => {
      return calculateValue(model, model.staffAttendance, "");
    },
    hideExpression: (context, values, model) => {
      return !model.doesChildAttend;
    },
    validation: Yup.number().when(["doesChildAttend"], ([doesChildAttend], schema) => {
      if (doesChildAttend != true) {
        return schema.notRequired();
      }
      return schema
        .required("A response is required")
        .min(1, "Please enter a number between 1 and 10")
        .max(10, "Please enter a number between 1 and 10");
    }),
  },
  {
    type: "field",
    key: "advisory",
    fieldType: "advisory",
    props: {
      type: "fieldadv",
      Body: () => (
        <div className="mb-2">
          Please enter the total number of regular employees of the service (teachers and educators) <strong>in the same room</strong> as the child -
          for this question do <strong>not</strong> count Additional Assistants
        </div>
      ),
    },
  },
];

export const groupInformationForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      key: "advisory1",
      fieldType: "advisory",
      label:
        "Please provide information about the hours the child attends on each day of the week and the group name for each day. If there are rotational groups please note all groups that attend on that day.",
    },
    {
      type: "field",
      key: "advisory2",
      fieldType: "advisory",
      props: {
        type: "warning",
        Body: () => (
          <>
            <p className="list-none pl-2 m-0">
              If multiple KIS applications are received from this kindergarten, this information is used to map which children attend the service at
              the same time as this child. Please ensure that the group names you use are consistent across the service, or we may be required to
              contact you for additional information which can delay processing.
            </p>
          </>
        ),
      },
      label: "",
    },
    {
      type: "formGroup",
      key: "groupInformationWeeklyData",
      props: {
        Body: ({ children }: any) => <> {Children.map(children, (child) => ({ child }))}</>,
      },
      fields: generateFormFields(),
    },
    {
      type: "field",
      key: "atleastOneDayOfTheWeek",
      fieldType: "error",
      validation: Yup.boolean().test("atleastOneDayOfTheWeek", "A response is required", function () {
        const { groupInformationWeeklyData } = this.parent;
        return (
          groupInformationWeeklyData.Monday.doesChildAttend ||
          groupInformationWeeklyData.Tuesday.doesChildAttend ||
          groupInformationWeeklyData.Wednesday.doesChildAttend ||
          groupInformationWeeklyData.Thursday.doesChildAttend ||
          groupInformationWeeklyData.Friday.doesChildAttend ||
          groupInformationWeeklyData.Saturday.doesChildAttend ||
          groupInformationWeeklyData.Sunday.doesChildAttend
        );
      }),
    },
    {
      type: "field",
      fieldType: "radio",
      key: "doesRotationalGroups",
      label: "Does the program run rotational groups?",
      extendedlabel: (
        <p className="list-none pl-2 m-0">
          A rotational model is where a number of smaller sub-groups are brought together to create a larger group. Each child is allocated with other
          children to a small group. These children always attend together throughout the week and will attend with other groups during the week.
          <br />
          Factsheets about the rotational model are available on the department’s{" "}
          <a
            href="https://www.education.vic.gov.au/Documents/childhood/providers/edcare/change-management-info-sheets-your-guide-to-rotational-models.pdf"
            target="_blank"
            title="Link opens in a new tab"
            rel="noreferrer">
            website<i aria-hidden="true" className="pi pi-external-link ml-1"></i>
          </a>
          .
        </p>
      ),
      validation: Yup.string().required("A response is required"),
      props: {
        options: [
          {
            label: "Yes",
            value: 1,
          },
          {
            label: "No",
            value: 0,
          },
        ],
      },
    },
    {
      type: "field",
      fieldType: "radio",
      label: "Do these group/s operate bush kinder sessions during the year?",
      extendedlabel: (
        <p className="list-none pl-2 m-0">
          If the kinder currently operates bush kinder sessions for this group/s, or is planning to during the year, you will be required to upload a
          Bush Kinder Risk Minimisation Plan at the end of this application.
          <br />
          Bush kinder includes beach kinder and kinder programs delivered in other outdoor settings external to the kindergarten, as part of a “bush
          kinder” program.
        </p>
      ),
      key: "doesBushKinderSessions",
      validation: Yup.string().required("A response is required"),
      props: {
        options: [
          {
            label: "Yes",
            value: 1,
          },
          {
            label: "No/Unsure",
            value: 0,
          },
        ],
      },
    },
    {
      type: "field",
      fieldType: "advisory",
      key: "advisory",
      hideExpression: (formContext, values, model) => !model.doesBushKinderSessions,
      label: (
        <>
          <label>Over what period does bush kinder operate?</label>
        </>
      ),
    },
    {
      type: "field",
      fieldType: "calendar",
      key: "startDate",
      label: "Start Date",
      hideExpression: (formContext, values, model) => !model.doesBushKinderSessions,
      validation: Yup.date().when(["endDate"], ([endDate], schema) => {
        if (endDate) {
          return schema.required("A response is required").max(endDate, "The start date must be earlier than the end date");
        }
        return schema.required("A response is required");
      }),
    },
    {
      type: "field",
      fieldType: "calendar",
      key: "endDate",
      label: "End date",
      hideExpression: (formContext, values, model) => !model.doesBushKinderSessions,
      validation: Yup.date().required("A response is required"),
    },
    {
      type: "field",
      fieldType: "textarea",
      props: {
        rows: 5,
        col: 30,
        autoResize: true,
      },
      key: "infoOfBushKinderSessions",
      label:
        "If there is any other information about the operation of bush kinder sessions that is important for the KIS assessment team to understand, please include it here.",
      hideExpression: (formContext, values, model) => !model.doesBushKinderSessions,
    },
    {
      type: "field",
      fieldType: "radio",
      key: "hasOtherSupport",
      label:
        "Thinking only about the year and group that relate to this application, has the group been allocated KIS support from another application?",
      validation: Yup.string().required("A response is required"),
      props: {
        options: [
          {
            label: "Yes",
            value: 1,
          },
          {
            label: "No",
            value: 0,
          },
        ],
      },
    },
    {
      type: "formGroup",
      label: "What KIS support has been allocated to this year? Select all that apply.",
      key: "kisSupport",
      hideExpression: (formContext, values) => !values.hasOtherSupport,
      fields: [
        {
          type: "field",
          fieldType: "checkbox",
          key: "specialistConsultancy",
          label: "Specialist consultancy",
        },
        {
          type: "field",
          fieldType: "checkbox",
          key: "additionalAssistant",
          label: "Additional assistant",
        },
        {
          type: "field",
          fieldType: "checkbox",
          key: "specialistTraining",
          label: "Specialist training",
        },
        {
          type: "field",
          fieldType: "checkbox",
          key: "minorBuildingModifications",
          label: "Minor building modifications",
        },
      ],
      test: [
        "atleastOneKisSupport",
        "A response is required",
        (value) => value.minorBuildingModifications || value.specialistTraining || value.additionalAssistant || value.specialistConsultancy,
      ],
    },
    {
      type: "formGroup",
      label:
        "Thinking only about the year and group that relate to this application, what supports are your kindergarten group accessing from other programs? Select all that apply.",
      key: "otherSupport",
      fields: [
        {
          type: "field",
          key: "schoolReadinessFunding",
          fieldType: "checkbox",
          label: "School Readiness Funding (SRF)",
        },
        {
          type: "field",
          fieldType: "checkbox",
          key: "flexibleSupportPackages",
          label: "Flexible Support Packages (FSP)",
        },
        {
          type: "field",
          fieldType: "checkbox",
          key: "inclusionSupportPrograms",
          label: "Inclusion Support Programs (ISP)",
        },
        {
          type: "field",
          fieldType: "checkbox",
          key: "preschoolFieldOfficer",
          label: "Preschool Field Officer (PSFO)",
        },
        {
          type: "field",
          fieldType: "checkbox",
          key: "earlyChildhoodInterventionServices",
          label: "Early Childhood Intervention Services (ECIS)",
        },
        {
          type: "field",
          fieldType: "checkbox",
          key: "earlyChildhoodLearningAdvisors",
          label: "LOOKOUT Early Childhood Learning Advisors (ECLAs)",
        },
        {
          type: "field",
          fieldType: "checkbox",
          key: "accessToEarlyLearning",
          label: "Access to Early Learning (AEL)",
        },
        {
          type: "field",
          fieldType: "checkbox",
          key: "mentalHealthInEarlyChildhood",
          label: "Mental Health in Early Childhood (HEC) Program / Early Childhood Mental Health Consultation",
        },
        {
          type: "field",
          fieldType: "checkbox",
          key: "supportFromOtherProgramsOther",
          label: "Other - please specify",
        },
        {
          type: "field",
          fieldType: "checkbox",
          key: "supportFromOtherPrograms",
          label: "None of the above",
        },
      ],
      test: [
        "atleastOneOtherSupport",
        "A response is required",
        (value) =>
          value.supportFromOtherPrograms ||
          value.supportFromOtherProgramsOther ||
          value.mentalHealthInEarlyChildhood ||
          value.accessToEarlyLearning ||
          value.earlyChildhoodLearningAdvisors ||
          value.preschoolFieldOfficer ||
          value.inclusionSupportPrograms ||
          value.flexibleSupportPackages ||
          value.schoolReadinessFunding ||
          value.earlyChildhoodInterventionServices,
      ],
    },

    {
      type: "field",
      fieldType: "textarea",
      key: "otherPrograms",
      label: "Please specify the other program/s you have received support from this year",
      hideExpression: (formContext, values) => !values.otherSupport.supportFromOtherProgramsOther,
      validation: Yup.string().trim().required("A response is required"),
    },
    {
      type: "field",
      fieldType: "textarea",
      key: "additionalEducators",
      label:
        "Please describe the title and role of any additional educators in attendance that assist the teaching team, such as additional assistants placed through the School Readiness Funding Program or a Flexible Support Package.",
    },
  ],
};
